import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SortBy, SortDirection } from '../../types/domainTypes';

interface ProjectsPageState {
  page: number;
  sortBy: SortBy;
  sortDirection: SortDirection;
  search: string;
}

const initialState: ProjectsPageState = {
  page: 1,
  sortBy: SortBy.LastModified,
  sortDirection: SortDirection.Descending,
  search: '',
};

function isSortByDate(sortBy: SortBy) {
  return sortBy === SortBy.LastModified || sortBy === SortBy.DateCreated;
}

export const projectsPageSlice = createSlice({
  name: 'projectsPage',
  initialState,
  reducers: {
    setPage: (state, { payload: page }: PayloadAction<number>) => {
      state.page = page;
    },
    setSortBy: (state, { payload: sortBy }: PayloadAction<SortBy>) => {
      state.page = 1;
      state.sortBy = sortBy;
      state.sortDirection = isSortByDate(sortBy) ? SortDirection.Descending : SortDirection.Ascending;
    },
    setSortDirection: (state, { payload: sortDirection }: PayloadAction<SortDirection>) => {
      state.page = 1;
      state.sortDirection = sortDirection;
    },
    setSearch: (state, { payload: search }: PayloadAction<string>) => {
      state.page = 1;
      state.search = search;
    },
  },
});

export const { setPage, setSortBy, setSortDirection, setSearch } = projectsPageSlice.actions;

export default projectsPageSlice.reducer;
